

import TiwiMixin from '../../mixins/TiwiMixin';
import ModalPopup from '../ModalPopup';

export default {
    mixins: [TiwiMixin],
    components: {
        ModalPopup
    },
    props: {
        onSubmit: {
            required: false,
            default: () => { },
            type: Function
        },
        /* onClose: {
            required: false,
            default: () => { },
            type: Function
        }, */
        roles: {
            required: false,
            default: {},
            type: Object
        },
    },
    data() {
        return {
            showModal: false,
            form: {
                email: '',
                name: '',
                nickname: '',
                phone: '',
                pronouns: [],
                role: '',
                surname: ''
            }
        }
    },
    mounted: function () {

    },
    methods: {
        saveUserData: function () {
            const self = this;

            self.setLoading(true);
            this.api.post('users/update', this.form, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            })
                .then((response) => {
                    if (response.data.success) {
                        self.toast.success('Profilo aggiornato correttamente!');
                        this.onSubmit(response, this.form);
                        this.updateDeskUser(); // faccio la chiamata API per aggiornare su DESK i meta dell'utente

                        this.showModal = false;

                        // Ricarica la pagina dopo 1 secondo se tutto ok

                        const search_params = new URLSearchParams(window.location.search);

                        if( !search_params.has('no_redirect') ){
                            setTimeout(function() {
                                location.reload();
                            }, 1000);
                        }
                        
                    }
                    else {
                        self.toast.error(response.data.message);
                    }

                    console.log(response.data, this.form);
                })
                .catch((error) => {
                    self.toast.error('Errore nella richiesta');
                })
                .finally(() => self.setLoading(false))
        },
        toggleModal: function () {
            if (this.showModal) {
                this.onClose(this.form);
            }

            this.showModal = !this.showModal;
        },
        checkboxChange: function (field, value) {
            this.form[field] = [value];
        },
        onClose: function() {
            this.showModal = false;
        }
    },
    watch: {
        user: function (user) {
            this.form.nickname = user.display_name;
            this.form.first_name = user.first_name;
            this.form.last_name = user.last_name;
            this.form.email = user.email;
            this.form.pronouns = [user.meta.pronouns];
            this.form.phone = user.meta.phone;
            this.form.reset_password_link = user.reset_password_link;
            this.form.marketing_emails = user.meta.marketing_emails_accepted;

            Object.keys(this.roles).forEach(role => {
                if (user.roles.includes(role)) {
                    this.form.role = role;
                    return;
                }
            });
        }
    }
}
